const carouselSelector = '.cmp-carousel'
const currentItemWrapper = '.cmp-carousel__current-item'
const activeIndicator = '.cmp-carousel__indicator--active'

const pauseYoutubeVideosInCarousel = carousel => {
  const youtubeIframes = carousel.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="youtube-nocookie.com"]')

  youtubeIframes.forEach(iframe => {
    iframe.contentWindow?.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: [],
      }),
      '*', 
    )
  })
}

const updateCurrentItemWrapper = (carouselCurrentItemWrapper, currentItem, numberOfListItems) => {
  if (!carouselCurrentItemWrapper) {
    return
  }

  carouselCurrentItemWrapper.innerText = `${currentItem}/${numberOfListItems}`
}

const initCurrentItemCarousel = (carousel, carouselCurrentItemWrapper) => {
  const numberOfListItems = +carousel.dataset.carouselItems
  let currentItem = +carousel.querySelector(activeIndicator)?.dataset.indicatorid || 1
  const nextArrowSelector = '.cmp-carousel__action--next, [data-cmp-hook-carousel="next"]'
  const previousArrowSelector = '.cmp-carousel__action--previous, [data-cmp-hook-carousel="previous"]'

  carousel.addEventListener('click', event => {
    const nextArrow = event.target.closest(nextArrowSelector)
    const previousArrow = event.target.closest(previousArrowSelector)

    if (nextArrow) {
      pauseYoutubeVideosInCarousel(carousel)
      currentItem = currentItem + 1 > numberOfListItems ? 1 : currentItem + 1
      updateCurrentItemWrapper(carouselCurrentItemWrapper, currentItem, numberOfListItems)
      return
    }

    if (previousArrow) {
      pauseYoutubeVideosInCarousel(carousel)
      currentItem = currentItem - 1 < 1 ? numberOfListItems : currentItem - 1
      updateCurrentItemWrapper(carouselCurrentItemWrapper, currentItem, numberOfListItems)
    }
  })
}

const initCarousel = carousel => {
  const carouselCurrentItemWrapper = carousel.querySelector(currentItemWrapper)
  const numberOfListItems = +carousel.dataset.carouselItems

  if (carouselCurrentItemWrapper) {
    carouselCurrentItemWrapper.classList.toggle('cmp-carousel__current-item--hidden', numberOfListItems <= 3)
  }

  initCurrentItemCarousel(carousel, carouselCurrentItemWrapper)
}

const carousels = document.querySelectorAll(carouselSelector)

if (carousels?.length) {
  carousels.forEach(initCarousel)
}
